import React, { useState } from "react";
import { Link } from "react-router-dom";
import { H4, Image, LI, UL } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";
import { profileHeaderData } from "../../../Data/Layout/RightHeader";
import SvgIcon from "../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons";
import { getCurrentUser, logout } from "../../../services/auth";
import {
  getAPIURL,
  getStoreName,
  getUserID,
  getVendorID,
} from "../../../services/helper";
import { useDispatch } from "react-redux";
import { openView } from "../../../ReduxToolkit/Reducers/viewReducer";
import { useSelector } from "react-redux";
import {
  autoOpenRegister,
  closeRegister,
} from "../../../ReduxToolkit/Reducers/CartReducer";
import Swal from "sweetalert2";
import http from "../../../services/http";
import { fetchRegistersByVendor } from "../../../ReduxToolkit/Reducers/AppReducer";

export default function ProfileHeader() {
  const dispatch = useDispatch();
  const { register_id } = useSelector((state) => state.cart);
  const user = getCurrentUser();
  const store_name = getStoreName();
  const { avatar_url } = user || {};
  const profile_image = !avatar_url ? dynamicImage("user.png") : avatar_url;
  const vendor_id = getVendorID();
  const biller_id = getUserID();
  const api_url = getAPIURL();

  if (!user) return null;

  const handleLogout = async () => {
    if (register_id) {
      const result = await Swal.fire({
        title: "Close Register?",
        text: "You have an open register. It will be closed automatically.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, logout",
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        Swal.fire({
          title: "Closing Register...",
          allowOutsideClick: false,
          didOpen: () => Swal.showLoading(),
        });

        try {
          await dispatch(closeRegister({ register_id })).unwrap();
          Swal.close();
          logout();
          window.location.reload();
        } catch (error) {
          Swal.fire("Error", "Failed to close register", "error");
        }
      }
    } else {
      logout();
    }
  };

  const handleViewOpen = async (viewName) => {
    if (viewName === "end_day") {
      const result = await Swal.fire({
        title: "End of Day",
        text: "Are you sure you want to end the day?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, End Day!",
      });

      if (result.isConfirmed) {
        try {
          const response = await http.post(`${api_url}/end-day`, {
            vendor_id,
            biller_id,
          });

          if (response.data.success) {
            Swal.fire({
              title: "Success!",
              text: "End Day process completed successfully.",
              icon: "success",
            }).then((result) => {
              window.location.reload();
            });
          } else {
            Swal.fire({
              title: "Failed",
              text: "Could not complete End Day. Please try again.",
              icon: "error",
            });
          }
        } catch (err) {
          console.error("Error ending day:", err);
          Swal.fire({
            title: "Error!",
            text: "An error occurred while processing End Day.",
            icon: "error",
          });
        } finally {
          dispatch(openView("registers"));
        }
      }
    } else {
      dispatch(openView(viewName));
    }
  };

  return (
    <LI className="profile-nav onhover-dropdown">
      <div className="onhover-click">
        <div className="sidebar-image">
          <Image src={profile_image} alt="profile" />
          <span className="status status-success"></span>
        </div>
        <div className="sidebar-content">
          <H4>{user?.user?.display_name}</H4>
          <span className="f-12 f-w-600 f-light">{store_name}</span>
          <div>Reg#: {register_id}</div>
        </div>
      </div>

      <UL className="profile-dropdown onhover-show-div simple-list">
        {profileHeaderData.map((item, index) => (
          <LI key={index}>
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                handleViewOpen(item.link);
              }}
            >
              <div className="profile-icon">
                <SvgIcon iconId={item.icon} />
              </div>
              <span>{item.text}</span>
            </Link>
          </LI>
        ))}

        <LI>
          <Link
            onClick={(e) => {
              e.preventDefault();
              handleLogout();
            }}
            to="#"
          >
            <div className="profile-icon">
              <SvgIcon iconId="login" />
            </div>
            <span>{"Log out"}</span>
          </Link>
        </LI>
      </UL>
    </LI>
  );
}
